// Reusable sidebar component for area profile details
import React from 'react';

const AreaProfileSidebar = ({ areaData }) => {
  if (!areaData) return null;

  return (
    <div>
      {areaData.fit && areaData.fit.length > 0 && (
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-1 text-white">Good Fit For</h3>
          <ul className="list-disc list-inside space-y-0">
            {areaData.fit.map((item, index) => (
              <li key={index} className="text-white/90">{item}</li>
            ))}
          </ul>
        </div>
      )}

      {areaData.tradeoffs && areaData.tradeoffs.length > 0 && (
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-1 text-white">Trade-offs</h3>
          <ul className="list-disc list-inside space-y-0">
            {areaData.tradeoffs.map((tradeoff, index) => (
              <li key={index} className="text-white/90">{tradeoff}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Metadata */}
      <div className="mb-4 space-y-1">
        {areaData.walkability && (
          <div className="flex items-center">
            <span className="font-semibold mr-2 text-white">Walkability:</span>
            <span className="text-white/90">
              {areaData.walkability === 'high' ? 'High - Easy to walk everywhere' :
               areaData.walkability === 'medium' ? 'Medium - Some walking possible' :
               'Low - Car recommended'}
            </span>
          </div>
        )}

        {areaData.beachProfile && (
          <div className="flex items-center">
            <span className="font-semibold mr-2 text-white">Beach Profile:</span>
            <span className="text-white/90">
              {areaData.beachProfile === 'protected' ? 'Protected - Calm, family-friendly waters' :
               areaData.beachProfile === 'snorkel' ? 'Snorkeling - Good visibility, marine life' :
               areaData.beachProfile === 'surf' ? 'Surf - Waves for experienced swimmers' :
               areaData.beachProfile === 'exposed' ? 'Exposed - Rough, scenic coastline' :
               areaData.beachProfile}
            </span>
          </div>
        )}

        {areaData.diningDensity && (
          <div className="flex items-center">
            <span className="font-semibold mr-2 text-white">Dining Scene:</span>
            <span className="text-white/90">
              {areaData.diningDensity === 'high' ? 'High - Many dining options' :
               areaData.diningDensity === 'medium' ? 'Medium - Several good restaurants' :
               'Low - Limited dining options'}
            </span>
          </div>
        )}
      </div>

      {areaData.logisticsNotes && (
        <div>
          <h3 className="text-xl font-semibold mb-2 text-white">Logistics & Getting Around</h3>
          <p className="text-white/90">{areaData.logisticsNotes}</p>
        </div>
      )}
    </div>
  );
};

export default AreaProfileSidebar;